import { render } from "./FooterDescription.vue?vue&type=template&id=311c5218&ts=true"
import script from "./FooterDescription.vue?vue&type=script&lang=ts"
export * from "./FooterDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__